import { r as registerInstance, c as createEvent, h, F as Fragment, g as getElement } from './index-d4808923.js';
import { b as bem } from './index.esm-7182addc.js';
import { c as createPopper } from './popper-1604923e.js';

const gravityNavigationDropdownCss = ":host{display:block;height:0;position:absolute;width:0;z-index:1000}.gravity-navigation-dropdown__dropdown{background-color:#FFFFFF;border-radius:6px;box-shadow:0px 8px 12px 0px rgba(0, 15, 30, 0.0392156863), 0px 2px 4px 0px rgba(0, 15, 30, 0.0196078431);box-sizing:border-box;opacity:0;pointer-events:none;position:fixed;transition:opacity 100ms cubic-bezier(0.32, 0, 0.32, 1);width:180px}.gravity-navigation-dropdown__dropdown__inner{display:block;margin-inline:auto;width:calc(100% - 2px)}.gravity-navigation-dropdown__dropdown::before{border:1px solid rgba(0, 15, 30, 0.2);border-radius:inherit;content:\"\";inset:0;pointer-events:none;position:absolute;z-index:1}.gravity-navigation-dropdown__dropdown--open{opacity:1;pointer-events:auto}.gravity-navigation-dropdown__dummy-option{display:block;height:0;visibility:hidden}";
const InternalGravityNavigationDropdownStyle0 = gravityNavigationDropdownCss;

const GravityNavigationDropdown = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.dropdownOptionClicked = createEvent(this, "dropdownOptionClicked", 1);
        this.isOpen = createEvent(this, "isOpen", 1);
        this.triggerElement = null;
        this.activeElement = null;
        this.generateClassNames = bem('gravity-navigation-dropdown');
        this.handleDropdownOptionClicked = (event) => {
            this.dropdownOptionClicked.emit({ id: event.detail });
            this.toggleDropdown();
        };
        this.handleTriggerClick = () => {
            this.toggleDropdown();
        };
        this.handleDropdownInnerHide = () => {
            if (this.isDropdownOpen) {
                this.toggleDropdown();
            }
        };
        this.for = undefined;
        this.offset = 'medium';
        this.options = [];
        this.isDropdownOpen = false;
    }
    handleWindowClick(event) {
        if (!this.isDropdownOpen || this.isClickInside(event)) {
            return;
        }
        this.toggleDropdown();
    }
    handleToolbarResize() {
        if (this.isDropdownOpen) {
            this.isDropdownOpen = false;
        }
    }
    isClickInside(event) {
        const path = event.composedPath();
        return path.some((element) => element === this.triggerElement || element === this.hostElement);
    }
    async toggleDropdown() {
        var _a, _b, _c, _d;
        this.isDropdownOpen = !this.isDropdownOpen;
        this.isOpen.emit(this.isDropdownOpen);
        await ((_a = this.popperInstance) === null || _a === void 0 ? void 0 : _a.update());
        // Required for innerDropdown.keyboardNavigation to work
        if (this.isDropdownOpen) {
            // Keep a reference to the active element when the dropdown is opened
            this.activeElement = ((_c = (_b = this.triggerElement) === null || _b === void 0 ? void 0 : _b.shadowRoot) === null || _c === void 0 ? void 0 : _c.activeElement) || this.triggerElement;
            // Temporarily enable focus on the dropdown to enable keyboard navigation
            this.hostElement.tabIndex = 0;
            this.hostElement.focus();
            this.hostElement.tabIndex = -1;
        }
        else {
            // Restore focus to the active element when the dropdown is closed
            (_d = this.activeElement) === null || _d === void 0 ? void 0 : _d.focus();
        }
    }
    getOffsetDistance() {
        return this.offset === 'small' ? 8 : 12;
    }
    createPopper() {
        if (!this.triggerElement || this.popperInstance || !this.dropdownElement) {
            return;
        }
        const offsetDistance = this.getOffsetDistance();
        this.popperInstance = createPopper(this.triggerElement, this.dropdownElement, {
            strategy: 'fixed',
            placement: 'bottom-end',
            modifiers: [
                {
                    name: 'offset',
                    options: {
                        offset: [0, offsetDistance],
                    },
                },
                {
                    name: 'preventOverflow',
                    options: {
                        padding: 8,
                        altAxis: true,
                    },
                },
                {
                    name: 'flip',
                    options: {
                        fallbackPlacements: ['top-end', 'bottom-start', 'top-start'],
                    },
                },
            ],
        });
    }
    destroyPopper() {
        var _a;
        (_a = this.popperInstance) === null || _a === void 0 ? void 0 : _a.destroy();
        this.popperInstance = undefined;
    }
    setupTriggerElement() {
        var _a, _b;
        this.triggerElement = (_a = this.hostElement.parentElement) === null || _a === void 0 ? void 0 : _a.querySelector(`#${this.for}`);
        (_b = this.triggerElement) === null || _b === void 0 ? void 0 : _b.addEventListener('click', this.handleTriggerClick);
    }
    componentWillLoad() {
        this.setupTriggerElement();
    }
    componentDidRender() {
        if (!this.popperInstance) {
            this.createPopper();
        }
    }
    disconnectedCallback() {
        this.destroyPopper();
        this.popperInstance = undefined;
    }
    render() {
        return (h(Fragment, { key: '45d6735d18a93bea8dfdf0dd2c1bc8a918495cc3' }, this.options.length > 0 && (h("div", { key: '06cc49723ab7e5cd93b656460ca0d9b70bc2f3d0', class: this.generateClassNames('dropdown', {
                open: this.isDropdownOpen,
            }), ref: (el) => (this.dropdownElement = el) }, h("gravity-dropdown-inner", { key: '1f35ba65d0d014ecd22df595ae9f8046e93a95f5', class: this.generateClassNames('dropdown__inner'), dropdown: this.hostElement, keyboardNavigation: this.isDropdownOpen, onDropdownOptionClicked: this.handleDropdownOptionClicked, onHide: this.handleDropdownInnerHide, options: this.options, selectionBehavior: false, size: "small", width: "fixed" }, h("slot", { key: 'dd762e5162d206c25d59f4b4fce99302eae03aaa', name: "header", slot: "header" }))))));
    }
    get hostElement() { return getElement(this); }
};
GravityNavigationDropdown.style = InternalGravityNavigationDropdownStyle0;

export { GravityNavigationDropdown as internal_gravity_navigation_dropdown };

//# sourceMappingURL=internal-gravity-navigation-dropdown.entry.js.map